// @ts-nocheck

import React from 'react';


import { convertEmployeeToString } from '../../../lib/helpers';
import DriverSelect from '../../../components/selects/DriverSelect';

import DriverWarningIndicator from './DriverWarningIndicator';
import DriverInfoPopover from './DriverInfoPopover';






/**
 * Селект водителей в инвентарной карточке ТС
 *
 * Выводит в списке предупреждающий маркер напротив водителей,
 * у которых квалификации несоответствуют для данной ТС
 */
const VehicleDriverSelect = ({ vehicle, ...selectProps }) =>
<DriverSelect
  {...selectProps}
  placeholder="Выберите водителя"
  renderOption={(driver, Option) =>
  <Option key={driver.id} value={driver.id}>
        {convertEmployeeToString(driver.employee)}
        <DriverWarningIndicator driver={driver} vehicle={vehicle} />
        <DriverInfoPopover driver={driver} />
      </Option>
  } />;



export default VehicleDriverSelect;
